var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFaqfull(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 16.5C5 9.625 10.625 4 17.5 4C24.375 4 30 9.625 30 16.5C30 23.375 24.375 29 17.5 29C10.625 29 5 23.375 5 16.5Z",
    fill: "#32373A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8336 13.9952C23.8336 12.2993 23.0225 11.0211 21.84 10.199C20.7005 9.40667 19.247 9.04955 17.8479 9.00486C16.442 8.95996 14.9749 9.22598 13.7525 9.80312C12.5428 10.3742 11.4271 11.3275 11.0419 12.7301C10.8713 13.3515 11.2367 13.9935 11.8581 14.1641C12.4794 14.3347 13.1214 13.9693 13.292 13.348C13.4318 12.8386 13.8911 12.318 14.7487 11.9131C15.5934 11.5143 16.6857 11.3023 17.7735 11.337C18.8682 11.372 19.8428 11.6522 20.508 12.1147C21.1302 12.5474 21.5003 13.1415 21.5003 13.9952C21.5003 14.7909 21.0282 15.3999 20.1023 15.886C19.1651 16.3781 17.9799 16.6074 17.156 16.6543C16.5384 16.6895 16.0556 17.2005 16.0556 17.8191V19.1111C16.0556 19.7554 16.5779 20.2778 17.2222 20.2778C17.8666 20.2778 18.3889 19.7554 18.3889 19.1111V18.8577C19.2704 18.7092 20.2803 18.4279 21.1869 17.9519C22.5166 17.2538 23.8336 16.0038 23.8336 13.9952ZM17.2222 21.0556C16.3631 21.0556 15.6667 21.752 15.6667 22.6111C15.6667 23.4702 16.3631 24.1667 17.2222 24.1667C18.0814 24.1667 18.7778 23.4702 18.7778 22.6111C18.7778 21.752 18.0814 21.0556 17.2222 21.0556Z",
    fill: "#E1D9CD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqfull);
export default __webpack_public_path__ + "static/media/faqfull.00b0909433c1cce88ad4847363403d18.svg";
export { ForwardRef as ReactComponent };